import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Dashboard from "@/pages/Dashboard";
import AstrologerPortal from "@/pages/AstrologerPortal";
import ChatClientPage from "@/pages/ChatClientPage";
import AdminAppointments from "@/pages/AdminAppointments";
import MarketPage from "@/pages/MarketPage";
import CaseTakingPage from "@/pages/CaseTakingPage";
import HandwritingPage from "@/pages/HandwritingPage";
import ChecklistAnalysisPage from "@/pages/ChecklistAnalysisPage";
import LibraryPage from "@/pages/LibraryPage";
import { Hand, Smile } from "lucide-react";
import ConsultPage from "@/pages/ConsultPage";
import ConsultRoomPage from "@/pages/ConsultRoomPage";
import ConsultAdminPage from "@/pages/ConsultAdminPage";
import VedasPage from "@/pages/VedasPage";
import InstallPrompt from "@/components/InstallPrompt";
import PinGate from "@/components/PinGate";
import { LanguageProvider } from "@/lib/i18n";

// Direct-Access mode — the PIN gate is disabled; every route is
// immediately open. We keep the wrapper name so route paths stay
// unchanged, but it now just renders the children.
const Locked = ({ children }) => <>{children}</>;

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
        <Routes>
          {/* Home window & Commercial Control Panel removed — both redirect
              straight into the Astrology Materia Hub (Dashboard). */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/astromeet-admin" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/studio" element={<Dashboard />} />
          <Route path="/astrologer-portal" element={<AstrologerPortal />} />
          <Route path="/chat/:bookingId" element={<ChatClientPage />} />
          <Route path="/market" element={<Locked subtitle="Stock Market — enter PIN"><MarketPage /></Locked>} />
          <Route path="/case-taking" element={<Locked subtitle="Case Taking — enter PIN"><CaseTakingPage /></Locked>} />
          <Route path="/handwriting" element={<Locked subtitle="Handwriting — enter PIN"><HandwritingPage /></Locked>} />
          <Route path="/library" element={<Locked subtitle="Library — enter PIN"><LibraryPage /></Locked>} />
          <Route path="/palmistry" element={
            <Locked subtitle="Palmistry — enter PIN">
              <ChecklistAnalysisPage
                moduleKey="palmistry"
                title="Palmistry"
                subtitle="based on Cheiro's system"
                pageIcon={Hand}
                uploadHint="a photo of your palm"
                pdfBasename="palmistry-report"
                testidPrefix="palm"
              />
            </Locked>
          } />
          <Route path="/face-reading" element={
            <Locked subtitle="Face Reading — enter PIN">
              <ChecklistAnalysisPage
                moduleKey="facereading"
                title="Face Reading"
                subtitle="based on Mary O. Stanton's Scientific Physiognomy"
                pageIcon={Smile}
                uploadHint="a clear front-facing photo"
                pdfBasename="face-reading-report"
                testidPrefix="face"
              />
            </Locked>
          } />
          <Route path="/consult" element={<ConsultPage />} />
          <Route path="/consult/:bookingId" element={<ConsultRoomPage />} />
          <Route path="/consult-admin" element={<ConsultAdminPage />} />
          <Route path="/vedas" element={<Locked subtitle="Vedas Hall — enter PIN"><VedasPage /></Locked>} />
          <Route path="/admin" element={<AdminAppointments />} />
          <Route path="*" element={<Dashboard />} />
        </Routes>
        <InstallPrompt />
        <Toaster theme="dark" position="top-right" />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
